import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CampaignAssignedDropdown from '../../Shared/CampaignAssignmentDropdown/index.tsx';
import {
  Dashboard as DashboardIcon,
} from '@mui/icons-material';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  Popover, TextField, Divider
} from '@mui/material';
import { useRecoilState } from 'recoil';
import {
  campaignLeadManagementAtom,
  leadsTableStateAtom,
} from '../../../Services/_states/index.js';
import { ConstantActions, LeadFormActions } from '../../../Services/_actions/index.js';
import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
import { globalpermissions } from '../../../Services/Permission.js';
import ListIcon from '@mui/icons-material/List';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import MoreVertIcon from "@mui/icons-material/MoreVert";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import StarIcon from "@mui/icons-material/Star";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import { he } from 'date-fns/locale';
import { dateFormate } from '../../../utils/helper.jsx';
import { max } from 'date-fns';

const DashboardHeader = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElPopover, setAnchorElPopover] = useState(null);
  const open = Boolean(anchorEl);
  const openPopover = Boolean(anchorElPopover);
  const handleMenu = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => {
    setAnchorElPopover(null)
    setAnchorEl(null);
  };
  const handleClick = (event) => setAnchorElPopover(event.currentTarget);

  const actions = LeadFormActions();
  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [hasCampaign, setHasCampaign] = useState(false);
  const [campaignLeadManagementData, setCampaignLeadManagementData] = useRecoilState(
    campaignLeadManagementAtom
  );
  const [tableState, setTableState] = useRecoilState<any>(leadsTableStateAtom);
  const navigate = useNavigate();
  const { showSnackBar } = useSnackBar();
  const constantActions = ConstantActions();
  // const [viewMode, setViewMode] = useState<'dropdown' | 'tabs'>('dropdown');
  const [allCampaigns, setAllCampaigns] = useState<any[]>([]);

  const handleAddForm = () => {
    const campaignId = campaignLeadManagementData?.selectedCampaign?.proposal_id;
    if (!campaignId) {
      showSnackBar('Please select a campaign first.', 'error');
      return;
    }
    navigate(`/r/records/${campaignId}/createForm`);
  };

  const getStatusList = async (form) => {
    if (!form?.leads_form_id) {
      console.warn('Missing `leads_form_id` in form:', form);
      return;
    }
    if (
      campaignLeadManagementData?.selectedCampaign?.proposal_id &&
      campaignLeadManagementData?.statusData?.[form.leads_form_id]?.length > 0
    ) {
      return;
    }
    let statusList = [];
    try {
      const payload = {
        active: { value: true },
        leadFormId: form.leads_form_id,
      };

      const res = await actions.fetchStatusAndSubStatus(payload);
      if (res?.status === 200 && Array.isArray(res.data)) {
        statusList = res.data;
      }
    } catch (error) {
      showSnackBar('Failed to fetch status list:', 'error');
    } finally {
      setCampaignLeadManagementData((prev) => ({
        ...prev,
        selectedForm: form,
        statusData: {
          ...(prev?.statusData || {}),
          [form.leads_form_id]: statusList,
        },
      }));
    }
  };

  const handleSelectCampaign = async (e) => {
    let leadForms = [];
    try {
      if (e?.proposal_id) {
        const response = await actions.getFormsByCampaignId(e?.proposal_id);
        if (response?.status === 200) {
          leadForms = Object.values(response?.data);
        }
      } else {
        showSnackBar('Missing campaign id', 'error');
      }
    } catch (error) {
      showSnackBar('Failed to fetch forms:', 'error');
    } finally {
      setCampaignLeadManagementData((prev) => ({
        ...prev,
        selectedCampaign: e,
        [e?.proposal_id]: leadForms,
        selectedForm: leadForms?.length > 0 ? leadForms[0] : null,
      }));
      if (leadForms?.length > 0) {
        getStatusList(leadForms[0]);
        setTableState((prev) => ({
          // ...prev,
          cache: {},
          filters: {
            ...prev.filters,
            campaign_id: e?.proposal_id,
            leads_form_id: leadForms[0]?.leads_form_id,
          },
        }));
      }
      const localData = { campaign: e ?? null, webForm: leadForms[0] ?? null };
      localStorage.setItem('leadWebFormData', JSON.stringify(localData));
    }
  };

  // const hasCampaign = Boolean(campaignLeadManagementData?.selectedCampaign);

  const handleMappingClick = () => {
    const campaign = campaignLeadManagementData?.selectedCampaign;
    if (!campaign?.proposal_id) {
      showSnackBar('Please select a campaign first.', 'error');
      return;
    }

    const localData = {
      campaign,
      webForm: campaignLeadManagementData?.selectedForm ?? null,
    };
    localStorage.setItem('leadWebFormData', JSON.stringify(localData));
    navigate(`/r/records/${campaign.proposal_id}/campaign-mapping`);
  };

  // const handleViewChange = (_e, newMode) => {
  //   if (newMode) setViewMode(newMode);
  // };

  const handleCampaignsFetched = (list: any[]) => {
    setAllCampaigns(list || []);
  };



  function moveObjectToFirst(myArray, objectId) {
    const movedObject = myArray.find((item) => item?.leads_form_id === objectId);
    if (!movedObject) {
      return myArray;
    }
    const remainingItems = myArray.filter((item) => item?.leads_form_id !== objectId);
    return [movedObject, ...remainingItems];
  }

  const fetchDataByLocalCampaign = async (localCampaign, localWebForm) => {
    let leadForms = [];
    try {
      if (localCampaign?.proposal_id) {
        const response = await actions.getFormsByCampaignId(localCampaign?.proposal_id);
        if (response?.status === 200) {
          leadForms = Object.values(response?.data);
          if (leadForms?.length > 3) {
            leadForms = moveObjectToFirst(leadForms, localWebForm?.leads_form_id);
          }
          setCampaignLeadManagementData((prev) => ({
            ...prev,
            selectedCampaign: localCampaign,
            [localCampaign?.proposal_id]: leadForms,
            selectedForm: localWebForm,
          }));
          getStatusList(localWebForm);
          setTableState((prev) => ({
            // ...prev,
            cache: {},
            filters: {
              ...prev.filters,
              campaign_id: localCampaign?.proposal_id,
              leads_form_id: localWebForm?.leads_form_id,
            },
          }));
        }
      } else {
        showSnackBar('Please Select', 'error');
      }
    } catch (error) {
      showSnackBar('Failed to fetch forms:', 'error');
    } finally {
      // const localData = { campaign: e ?? null, webForm: leadForms[0] ?? null };
      // localStorage.setItem('leadWebFormData', JSON.stringify(localData));
    }
  };

  useEffect(() => {
    const localData = localStorage.getItem('leadWebFormData');
    try {
      if (localData) {
        const { campaign, webForm } = JSON.parse(localData);
        if (campaign && webForm) {
          fetchDataByLocalCampaign(campaign, webForm);
          // setCampaignLeadManagementData((prev) => ({
          //   ...prev,
          //   selectedCampaign: campaign,
          // }));
        }
      }
    } catch (error) {
      console.error('Error parsing local storage data:', error);
    }
  }, []);

  const headerTitle =
    campaignLeadManagementData?.selectedCampaign?.campaign_name ||
    campaignLeadManagementData?.selectedCampaign?.name ||
    '';


  return (
    <>
      <Box display="flex" alignItems="center" pb={1} sx={{ pt: { xs: 2, sm: 0 } }}>
        <CampaignAssignedDropdown
          label={(hasCampaign || Boolean(campaignLeadManagementData?.selectedCampaign)) ? '' : 'Select Dashboard'}
          onChange={(e) => { handleSelectCampaign(e) }}
          value={campaignLeadManagementData?.selectedCampaign ?? null}
          autoSelectValue={true}
          // organisationId={campaignLeadManagementData?.selectedCampaign?.organisation_id ?? ''}
          organisationId={campaignLeadManagementData?.selectedCampaign?.organisation_id ?? tableState?.filters?.organisation_id
            ?? ''}
          sx={{
            '& .MuiOutlinedInput-root': {
              backgroundColor: 'rgba(255,255,255,0.9)',
              borderRadius: 2,
              color: 'text.primary',
              maxWidth: { sm: 300, xs: '100%' },
            },
          }}
          onOpen={() => setHasCampaign(true)}
          onClose={() => setHasCampaign(false)}
        // onCampaignsFetched={(list) => setAllCampaigns(list || [])}
        />
        {campaignLeadManagementData?.selectedCampaign && (
          constantActions.userHasPermission([
            globalpermissions?.leadDashboard?.createWebForm,
          ]) ||
          constantActions.userHasPermission([
            globalpermissions?.leadDashboard?.mappingLead,
          ])
        ) && (
            <Box display="flex" alignItems="center" gap={1}>
              <IconButton onClick={handleMenu}>
                <MoreVertIcon />
              </IconButton>

              <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                <>
                  {constantActions.userHasPermission([globalpermissions?.leadDashboard?.createWebForm]) && (
                    <MenuItem onClick={() => handleAddForm()}>
                      <AddCircleOutlineIcon fontSize="small" sx={{ mr: 1 }} />
                      Add Form
                    </MenuItem>
                  )}
                  {constantActions.userHasPermission([globalpermissions?.leadDashboard?.mappingLead]) && (
                    <MenuItem onClick={() => handleMappingClick()}>
                      <ListIcon fontSize="small" sx={{ mr: 1 }} />
                      Mapping List
                    </MenuItem>
                  )}
                </>
              </Menu>
            </Box>
          )}
      </Box>
      {/* <Popover
        open={openPopover}
        anchorEl={anchorElPopover}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          sx: {
            // bgcolor: "#1e2235",
            // color: "#fff",
            p: 2,
            borderRadius: 2,
            width: 320,
          },
        }}
      >
        <Typography
          variant="h6"
          sx={{ fontWeight: 600, mb: 1, display: "flex", alignItems: "center", gap: 1 }}
        >
          Select Dashboard
          <StarBorderIcon sx={{ fontSize: 20, color: "#888" }} />
        </Typography>
        <CampaignAssignedDropdown
          label={(hasCampaign || Boolean(campaignLeadManagementData?.selectedCampaign)) ? '' : 'Select Dashboard'}
          onChange={(e) => { handleSelectCampaign(e) }}
          value={campaignLeadManagementData?.selectedCampaign ?? null}
          autoSelectValue={true}
          // organisationId={campaignLeadManagementData?.selectedCampaign?.organisation_id ?? ''}
          organisationId={campaignLeadManagementData?.selectedCampaign?.organisation_id ?? tableState?.filters?.organisation_id
            ?? ''}
          sx={{
            '& .MuiOutlinedInput-root': {
              backgroundColor: 'rgba(255,255,255,0.9)',
              borderRadius: 2,
              color: 'text.primary',
            },
          }}
          onOpen={() => setHasCampaign(true)}
          onClose={() => setHasCampaign(false)}
        // onCampaignsFetched={(list) => setAllCampaigns(list || [])}
        />
        {
          campaignLeadManagementData?.selectedCampaign && (
            <>
              <Divider sx={{ mb: 2 }} />

              <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                Dashboard info
              </Typography>

              <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                <Typography variant="body2" >
                  Type
                </Typography>
                <Typography variant="body2">{campaignLeadManagementData?.selectedCampaign?.campaign_state ?? ''}</Typography>
              </Box>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                <Typography variant="body2">
                  Created by
                </Typography>
                <Box display="flex" alignItems="center" gap={1}>
                  {campaignLeadManagementData?.selectedCampaign?.created_by &&
                    <Avatar sx={{ bgcolor: "#22c55e", width: 24, height: 24, fontSize: 12 }}>{campaignLeadManagementData?.selectedCampaign?.created_by[0]}</Avatar>
                  }
                  {campaignLeadManagementData?.selectedCampaign?.created_at && (
                    <Typography variant="body2">On {dateFormate(campaignLeadManagementData?.selectedCampaign?.created_at, 'DD-MM-YYYY,HH:MM A')}</Typography>
                  )}
                </Box>
              </Box>
            </>
          )
        }

      </Popover> */}

    </>
  );
};
export default DashboardHeader;
